import { useEffect } from 'react';
import useTrackFilters from '@hooks/tracking/useTrackFilters';
import { useInstantSearch } from 'react-instantsearch-core';
import { useDebounce } from '@monofront/business/hooks';
import { fireAutoMLEvent } from '@utils/tracking';

export const VirtualTrackSearchFilters = () => {
  const trackFilter = useTrackFilters();
  const { indexUiState } = useInstantSearch();

  const debouncedSearchTerm = useDebounce(indexUiState.query, 1000);

  useEffect(() => {
    trackFilter(indexUiState);
  }, [indexUiState]);

  useEffect(() => {
    if (debouncedSearchTerm) {
      fireAutoMLEvent('search', {
        productEventDetail: {
          searchQuery: `${debouncedSearchTerm}`,
        },
      });
    }
  }, [debouncedSearchTerm]);

  return null;
};
